
export const home = [
  {
    path: "/",
    meta: { title: "首页" },
    component: () => import("../../views/home/index.vue"),
  },
  {
    path: "/search",
    meta: { title: "搜索" },
    component: () => import("../../views/home/search.vue"),
  },
  {
    path: '/medical/disease',
    meta: { title: "诊疗服务-疾病列表" },
    component: () => import("../../views/medical/disease.vue")
  },
  {
    path: '/medical/academic',
    meta: { title: "学术中心" },
    component: () => import("../../views/medical/academic.vue")
  },
  {
    path: '/medical/diseaseDetail',
    meta: { title: "疾病列表-分类列表" },
    component: () => import("../../views/medical/diseaseDetail.vue")
  },
  {
    path: '/medical/thyroid',
    meta: { title: "疾病列表-甲状腺相关眼病" },
    component: () => import("../../views/medical/thyroid.vue")
  },
  {
    path: '/medical/urea1',
    meta: { title: "疾病列表-尿素循环障碍" },
    component: () => import("../../views/medical/urea1.vue")
  },
  {
    path: '/medical/urea2',
    meta: { title: "疾病列表-尿素循环障碍" },
    component: () => import("../../views/medical/urea2.vue")
  },
  {
    path: '/medical/drug',
    meta: { title: "诊疗服务-药品列表" },
    component: () => import("../../views/medical/drug.vue")
  },
  {
    path: '/medical/medic',
    meta: { title: "找药用药" },
    component: () => import("../../views//medical/medic.vue")
  },
  {
    path: '/medical/center',
    meta: { title: "专家团队" },
    component: () => import("../../views/medical/center.vue")
  },
  {
    path: '/medical/exteam',
    meta: { title: "专家团队" },
    component: () => import("../../views/medical/exteam.vue")
  },
  {
    path: '/medical/exteam/details',
    meta: { title: "专家详情" },
    component: () => import("../../views/medical/details.vue")
  },
  {
    path: '/medical/visitprocess',
    meta: { title: "就诊流程" },
    component: () => import("../../views/medical/visitprocess.vue")
  },
  {
    path: '/academic/literature',
    meta: { title: "文献情报" },
    component: () => import("../../views/academic/literature.vue")
  },
  {
    path: '/academic/case',
    meta: { title: "病例会践" },
    component: () => import("../../views/academic/case.vue")
  },
  {
    path: '/academic/metting',
    meta: { title: "会议新语" },
    component: () => import("../../views/academic/metting.vue")
  },
  {
    path: '/academic/big',
    meta: { title: "大咖沙龙" },
    component: () => import("../../views/academic/big.vue")
  },
  {
    path: '/academic/details',
    meta: { title: "大咖沙龙详情 || 视频详情" },
    component: () => import("../../views/academic/details.vue")
  },
  {
    path: '/academic/read',
    meta: { title: "读书会" },
    component: () => import("../../views/academic/read.vue")
  },
  {
    path: '/popular/love',
    meta: { title: "唯爱百科" },
    component: () => import("../../views/popular/love.vue")
  },
   {
    path: '/popular/policy',
    meta: { title: "医疗政策" },
    component: () => import("../../views/popular/policy.vue")
  },
   {
    path: '/popular/shout',
    meta: { title: "大咖罕话" },
    component: () => import("../../views/popular/shout.vue")
  },
  {
    path: '/patient/welfare',
    meta: { title: "公益项目" },
    component: () => import("../../views/patient/welfare.vue")
  },
  {
    path: '/patient/payment',
    meta: { title: "保险及支付" },
    component: () => import("../../views/patient/payment.vue")
  },
  {
    path: '/patient/story',
    meta: { title: "患者故事" },
    component: () => import("../../views/patient/story.vue")
  },
  {
    path: '/patient/story/details',
    meta: { title: "故事详情" },
    component: () => import("../../views/patient/details.vue")
  },
  {
    path: '/projects/medic',
    meta: { title: "全球找药" },
    component: () => import("../../views/projects/medic.vue")
  },
  {
    path: '/projects/scicoop',
    meta: { title: "科研合作" },
    component: () => import("../../views/projects/scicoop.vue")
  },
  {
    path: '/projects/excoop',
    meta: { title: "专家合作" },
    component: () => import("../../views/projects/excoop.vue")
  },
  {
    path: '/projects/racoop',
    meta: { title: "商业合作" },
    component: () => import("../../views/projects/racoop.vue")
  },
  {
    path: '/story/intro',
    meta: { title: "中心介绍" },
    component: () => import("../../views/story/intro.vue")
  },
  {
    path: '/story/vision',
    meta: { title: "愿景使命" },
    component: () => import("../../views/story/vision.vue")
  },
  {
    path: '/story/history',
    meta: { title: "发展历程" },
    component: () => import("../../views/story/history.vue")
  },
  {
    path: '/story/news',
    meta: { title: "新闻中心" },
    component: () => import("../../views/story/news.vue")
  },
  {
    path: '/story/article',
    meta: { title: "文章中心" },
    component: () => import("../../views/story/article.vue")
  },
  {
    path: '/story/details',
    meta: { title: "新闻中心详情" },
    component: () => import("../../views/story/details.vue")
  },
  {
    path: '/my/contact',
    meta: { title: "联系我们" },
    component: () => import("../../views/my/contact.vue")
  },
  {
    path: '/my/traffic',
    meta: { title: "交通指南" },
    component: () => import("../../views/my/traffic.vue")
  },
  {
    path: '/my/seek',
    meta: { title: "留言咨询" },
    component: () => import("../../views/my/seek.vue")
  },
  {
    path: '/improve',
    meta: { title: "完善资料" },
    component: () => import("../../views/my/improve.vue")
  },
  {
    path: '/hall',
    meta: { title: "唯爱讲堂" },
    component: () => import("../../views/home/hall.vue")
  },
  {
    path: '/privacy',
    meta: { title: "隐私政策" },
    component: () => import("../../views/home/privacy.vue")
  },
  {
    path: '/commitment',
    meta: { title: "患者承诺书" },
    component: () => import("../../views/home/commitment.vue")
  },
  {
    path: '/agreement',
    meta: { title: "服务类型" },
    component: () => import("../../views/home/agreement.vue")
  },
];
